import { all, takeLatest, takeLeading } from 'redux-saga/effects';

import * as constants from './constants';
import { startFetchPageSaga } from './saga.startFetchPage';
import { startUploadFileSaga } from './saga.startUploadFile';

// `takeLeading` for uploads — only one file in flight at a time.
// `takeLatest` for fetches — pagination clicks cancel previous fetches.
export function* watcher() {
  yield all([
    takeLeading(constants.START_UPLOAD_FILE, startUploadFileSaga),
    takeLatest(constants.START_FETCH_PAGE, startFetchPageSaga),
  ]);
}
